import { render, staticRenderFns } from "./PersonBaseInfo.vue?vue&type=template&id=12f7c72e&scoped=true&"
import script from "./PersonBaseInfo.vue?vue&type=script&lang=js&"
export * from "./PersonBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonBaseInfo.vue?vue&type=style&index=0&id=12f7c72e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f7c72e",
  null
  
)

export default component.exports